import createIcon from '../../createIcon';

/**
 * @component @name DarkMode
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgM0M3LjAzIDMgMyA3LjAzIDMgMTJDMyAxNi45NyA3LjAzIDIxIDEyIDIxQzE2Ljk3IDIxIDIxIDE2Ljk3IDIxIDEyQzIxIDExLjU0IDIwLjk2IDExLjA4IDIwLjkgMTAuNjRDMTkuOTIgMTIuMDEgMTguMzIgMTIuOSAxNi41IDEyLjlDMTMuNTIgMTIuOSAxMS4xIDEwLjQ4IDExLjEgNy41QzExLjEgNS42OSAxMS45OSA0LjA4IDEzLjM2IDMuMUMxMi45MiAzLjA0IDEyLjQ2IDMgMTIgM1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DarkMode = createIcon('DarkMode', [
  [
    'path',
    {
      d: 'M12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 11.54 20.96 11.08 20.9 10.64C19.92 12.01 18.32 12.9 16.5 12.9C13.52 12.9 11.1 10.48 11.1 7.5C11.1 5.69 11.99 4.08 13.36 3.1C12.92 3.04 12.46 3 12 3Z',
      key: '1wvusg',
    },
  ],
]);

export default DarkMode;
